//
// Copyright 2021 DXOS.org
//

// TODO(burdon): Random class utility.
// TODO(burdon): Make object { min, max }.
export const randomInt = (max: number, min = 0) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
